import React, { useEffect, useState } from 'react';
import { Button, Card, Col } from 'react-bootstrap';
import { PrimeWidgetSVG } from 'src/Member/img/PrimeWidgetSVG';
import './PrimeWidget.scss';
import { ResourcesSVG } from 'src/Member/img/GlobalSVG';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const PrimeWidget = () => {
  const { ClientLogoConfig } =
    useSelector((state) => state.app.appConfigs) || [];
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;
  const [showAdditionalWidget, setShowAdditionalWidget] = useState(false);
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const clientID = userData.MemberDetails.ClientID;
  const { t } = useTranslation();
  useEffect(() => {
    if (isLoggedIn) {
      const clientData = ClientLogoConfig.filter(
        (eachClientInfo) => eachClientInfo.ClientID === clientID,
      );
      const CustomDashboardWidget =
        FEATURES &&
        FEATURES?.find((feature) => feature.Name === 'CustomDashboardWidget');
      if (
        clientData?.length > 0 &&
        clientData[0].ClientType === 'Prime' &&
        CustomDashboardWidget &&
        CustomDashboardWidget.Status === true
      ) {
        setShowAdditionalWidget(true);
      }
    }
  }, [isLoggedIn]);

  return (
    <>
      {showAdditionalWidget ? (
        <Col className="col-md-4 margin-bottom-32 prime-widget">
          <Card className="find-care-container dashboard-data-space">
            <div className="">
              <PrimeWidgetSVG />
              <p className="h5 mt-3 prime-title">
                {t('member.dashboard.prime_widget.title')}
              </p>
              <div className="d-flex align-items-center">
                <div className="resource-file-type">
                  <div className="resource-item-info-icon">
                    <ResourcesSVG.ExternalLinkSVG className="fill-color" />
                  </div>
                </div>
                <div className="resource-content">
                  <a
                    target="_blank"
                    href="https://ehp.primehealthcare.com/"
                    className="resource-link-title"
                    rel="noreferrer"
                  >
                    {t('member.dashboard.prime_widget.click_here')}
                  </a>
                </div>
              </div>
            </div>
            <Card.Body className="p-0 pt-2">
              <p>{t('member.dashboard.prime_widget.sub_text')}</p>
            </Card.Body>
          </Card>
        </Col>
      ) : (
        <></>
      )}
    </>
  );
};

export default PrimeWidget;
